<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0 && canUserDelete"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteManyOperators()"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              type="primary"
              @click="$router.push('/suppliers/new')"
              class="min-button"
              v-if="canUserCreate"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Supplier</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>

                <b-input-group-append class="pt-1 pb-0">
                  <b-button
                    variant="neutro"
                    v-b-toggle.toggleFilters
                    class="p-0"
                  >
                    <i class="flaticon-equalizer"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-button
                  type="outline-neutral"
                  class="min-button"
                  v-if="query"
                  @click="resetSearchFilter()"
                >
                  <i class="flaticon-eraser"></i>Reset Search
                </base-button>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-rec"></i>
                    <strong>Status</strong>
                  </base-button>

                  <div
                    class="dropdown-item"
                    :class="accountStatus === 'ALL' ? 'active' : ''"
                    @click="applyFilterByStatus('ALL')"
                  >
                    <i class="flaticon-rec text-primary mr-2"></i>
                    All
                  </div>
                  <div
                    class="dropdown-item"
                    :class="accountStatus === 'ACTIVE' ? 'active' : ''"
                    @click="applyFilterByStatus('ACTIVE')"
                  >
                    <i class="flaticon-bold-check-3 text-success mr-2"></i>
                    Active
                  </div>
                  <div
                    class="dropdown-item"
                    :class="accountStatus === 'INACTIVE' ? 'active' : ''"
                    @click="applyFilterByStatus('INACTIVE')"
                  >
                    <i class="flaticon-bold-cancel text-danger mr-2"></i>
                    Inactive
                  </div>
                </base-dropdown>

                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-people-1"></i>
                    <strong>Type</strong>
                  </base-button>

                  <div
                    v-for="(service, index) in servicesProvided"
                    :key="index"
                    class="dropdown-item"
                    :class="serviceType === service.value ? 'active' : ''"
                    @click="applyFilterByService(service.value)"
                  >
                    {{ service.label }}
                  </div>
                </base-dropdown>

                <base-button
                  type="outline-neutral"
                  class="min-button"
                  v-b-toggle.toggleFilters
                >
                  <i class="flaticon-equalizer"></i>Advanced Search
                </base-button>

                <base-button
                  type="outline-neutral"
                  class="min-button"
                  v-if="canUserCreateTag"
                  @click="modalTags = true"
                >
                  <i class="flaticon-save-instagram mr-2"></i> Tags
                </base-button>
              </div>
            </div>
          </div>
        </div>

        <b-collapse id="toggleFilters" class="mt-2">
          <div class="filters-advanced forms">
            <div class="card pb-2">
              <div class="row">
                <div
                  class="col-lg-6 col-md-6 col-sm-4 col-12 align-self-center pb-4"
                >
                  <h4 class="underline mb-0">Filters</h4>
                </div>
                <div
                  class="col-lg-6 col-md-6 col-sm-8 col-12 text-right align-self-center pb-4"
                >
                  <base-button
                    type="outline-neutral"
                    class="min-button"
                    v-b-toggle.toggleFilters
                  >
                    <i class="flaticon-cancel"></i>
                    Close
                  </base-button>
                  <base-button
                    type="outline-neutral"
                    class="min-button"
                    @click="resetSearchFilter()"
                  >
                    <i class="flaticon-eraser"></i> Clear
                  </base-button>
                  <base-button
                    type="primary"
                    class="min-button mb-2"
                    @click="applyAdvancedSearch"
                  >
                    Apply
                  </base-button>
                </div>
              </div>
              <div class="row formsearch">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                  <WSelect
                    placeholder="Enter a Supplier"
                    v-model.trim="filters.supplier"
                    id="search_supplier"
                    name="search_supplier"
                    filterable
                    remote
                    reserve-keyword
                    label="Supplier"
                    @change="selectSupplier"
                    clearable
                  >
                    <el-option
                      v-for="supplier in operatorSelections"
                      :value="supplier._id"
                      :label="supplier.businessDetails.name"
                      :key="supplier._id"
                    >
                      <span class="hide-data-inline coin-left">
                        {{ supplier.businessDetails.name }}
                      </span>
                      <span class="hide-data-inline coin-right text-right">
                        {{ supplier.businessDetails.legalName }}
                      </span>
                    </el-option>
                  </WSelect>
                </div>

                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="First Name"
                    v-model.trim="filters.first_name"
                    id="search_firstname"
                    name="search_firstname"
                    label="Contact First Name"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Last Name"
                    v-model.trim="filters.last_name"
                    id="search_lastName"
                    name="search_lastName"
                    label="Contact Last Name"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                  <WSelect
                    placeholder="Enter a Destination"
                    v-model="filters.destination"
                    id="search_branch"
                    name="search_branch"
                    filterable
                    @change="selectDestination"
                    label="Destination"
                    clearable
                  >
                    <el-option
                      v-for="(destination, index) in destinationsOptions"
                      :value="destination.slug"
                      :label="
                        `${destination.city} - ${destination.country.name}`
                      "
                      :key="index"
                    >
                      <span class="hide-data-inline coin-left">{{
                        destination.city
                      }}</span>
                      <span class="hide-data-inline coin-right">{{
                        destination.country.name
                      }}</span>
                    </el-option>
                  </WSelect>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>

        <div class="row mt-2" v-if="activeFilter">
          <div class="col-12 text-right">
            <span><strong>Filtered by: </strong></span>

            <ul class="box-tags-filters">
              <li class="tags-filters" v-if="simpleSearch">
                {{ simpleSearch }}
              </li>

              <li class="tags-filters" v-if="supplierFilter">
                Supplier: {{ supplierFilter.businessDetails.name }}
              </li>

              <li class="tags-filters" v-if="filters.first_name != ''">
                Contact First Name: {{ filters.first_name }}
              </li>
              <li class="tags-filters" v-if="filters.last_name != ''">
                Contact Last Name:{{ filters.last_name }}
              </li>

              <li class="tags-filters" v-if="filters.destination != ''">
                Destination: {{ destinationName }}
              </li>

              <li class="d-inline-block">
                <span @click="resetSearchFilter()" class="curp"
                  ><i class="flaticon-cancel ml-2"></i
                ></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model="filterStatus"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                @change="filteredTab"
                class="buttons-rows-2"
              >
                <b-form-radio value="all">All</b-form-radio>

                <b-form-radio value="inactive"
                  >Inactive<badge type="danger" class="square">{{
                    inactive
                  }}</badge></b-form-radio
                >

                <b-form-radio value="affiliate"
                  >Unaffiliated<badge type="danger" class="square">{{
                    unaffiliated
                  }}</badge></b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-1 text-right"
          >
            <div class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block">
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-2"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <el-tooltip
                content="Manage columns"
                placement="bottom"
                class="d-inline-flex"
              >
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="modalManageColumn = true"
                >
                  <i class="flaticon-bold-settings mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>

            <div v-if="canUserExport" class="d-inline-block mr-2 mb-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-2"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download([])">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>
            <div class="d-inline-block mb-2">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div>
          <pagination-block
            :pageCount="operatorResponse.pages"
            :total="operatorResponse.count"
            :limit="limit"
            @changeLimit="changeLimit"
            v-model="currentPage"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="preventPaginations"
            position="bottom"
          ></pagination-block>

          <b-table
            hover
            :items="operators"
            :fields="fields"
            sort-by.sync="name"
            sort-asc.sync="true"
            selectable
            @row-selected="onRowSelected"
            select-mode="multi"
            ref="selectableTable"
            sort-icon-left
            responsive
            show-empty
            empty-filtered-text="There are no records matching your request"
            empty-text="There are no records to show"
            :stacked="cardview"
          >
            <template #head()="{ label, field: { key } }">
              <span v-if="key === 'selected'">
                <span
                  @click="clearSelected"
                  v-if="selectedRows.length == operators.length"
                  class="check-table selected"
                ></span>

                <span @click="selectAllRows" v-else class="check-table"></span>
              </span>
              <span v-else>{{ label }}</span>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true" class="check-table selected"></span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true" class="check-table"></span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template #cell(name)="data">
              <div class="d-flex align-items-center link-img-profile">
                <div
                  class="avatar"
                  :style="{
                    backgroundImage:
                      'url(' +
                      (data.item.businessDetails.image || imageProfile) +
                      ')'
                  }"
                >
                  <el-tooltip
                    content="Confirmed"
                    placement="bottom"
                    v-if="data.item.authentication.verified"
                  >
                    <i class="flaticon-bold-check-1 verified"></i>
                  </el-tooltip>
                </div>

                <div class="d-inline-flex">
                  <div>
                    <span
                      class="role-table capitalize"
                      v-if="data.item.affiliate === true"
                    >
                      Affilliated
                    </span>
                    <router-link
                      class="capitalize hide-data"
                      :to="`/suppliers/${data.item._id}`"
                      >{{ data.item.businessDetails.name }}</router-link
                    >
                  </div>
                </div>

                <el-popover
                  placement="bottom"
                  trigger="hover"
                  width="300"
                  class="curp d-inline-flex ml-1"
                  v-if="data.item.internalNotes || data.item.publicNotes"
                >
                  <div class="p-2">
                    <span>
                      <span v-if="data.item.internalNotes" class="d-block">
                        <strong>Internal Notes: </strong>
                        <span class="text-min hide-data-multiple">{{
                          data.item.internalNotes
                        }}</span>
                      </span>
                      <span v-if="data.item.publicNotes" class="mt-2 d-block">
                        <strong>Supplier Notes: </strong>
                        <span class="text-min hide-data-multiple">{{
                          data.item.publicNotes
                        }}</span>
                      </span>

                      <router-link
                        class="d-block text-right text-link"
                        :to="`/suppliers/${data.item._id}`"
                        >See more
                      </router-link>
                    </span>
                  </div>

                  <div slot="reference" class="d-flex badge badge-note">
                    Note
                  </div>
                </el-popover>
              </div>
            </template>

            <template #cell(type)="data">
              <span class="hide-data">{{
                getServiceType(data.item.serviceType)
              }}</span>
            </template>

            <template #cell(phone)="data">
              <span class="hide-data"
                >{{ getPhoneNumber(data.item.contactPerson.phoneNumbers) }}
                <el-tooltip
                  content="Copy"
                  placement="bottom"
                  v-if="getPhoneNumber(data.item.contactPerson.phoneNumbers)"
                >
                  <span
                    class="curp ml-1"
                    v-clipboard:copy="
                      getPhoneNumber(data.item.contactPerson.phoneNumbers)
                    "
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onErrorCopy"
                  >
                    <i class="flaticon-copy link ml-0"></i></span
                ></el-tooltip>
              </span>
            </template>

            <template #cell(email)="data">
              <a
                class="hide-data"
                :href="
                  `https://mail.google.com/mail/?view=cm&fs=1&to=${data.item.contactPerson.email}`
                "
                target="_blank"
                >{{ data.item.contactPerson.email }}</a
              >
              <el-tooltip
                content="Copy"
                placement="bottom"
                v-if="data.item.contactPerson.email"
              >
                <span
                  class="curp ml-1"
                  v-clipboard:copy="data.item.contactPerson.email"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onErrorCopy"
                >
                  <i class="flaticon-copy link ml-0"></i></span
              ></el-tooltip>
            </template>

            <template #cell(website)="data">
              <span class="hide-data" v-if="data.item.businessDetails.website">
                {{ data.item.businessDetails.website }}
              </span>
              <span class="hide-data" v-else>-</span>
            </template>

            <template #cell(preferredContactMethod)="data">
              <span class="hide-data">{{
                getPreferredContactMethod(data.item.preferredContactMethod)
              }}</span>
            </template>

            <template #cell(contactPerson)="data">
              <span class="hide-data-2"
                >{{ data.item.contactPerson.firstName }}
                {{ data.item.contactPerson.lastName }}</span
              >
            </template>

            <template #cell(address)="data">
              <span class="role-table">{{ data.item.address.city }}</span>
              <span class="hide-data">{{ data.item.address.country }}</span>
            </template>

            <template #cell(destinations)="data">
              <span class="hide-data">{{ data.item.destinationsSummary }}</span>
            </template>

            <template #cell(rates)="data">
              <span class="hide-data">{{
                data.item.ratesSummary.affiliate
              }}</span>
            </template>

            <template #cell(taxes)="data">
              {{ data.item.settings.taxes.type.toUpperCase() }}
              {{ data.item.settings.taxes.value }}%
            </template>

            <template #cell(tags)="data">
              <span class="hide-data-2">{{ getTagNames(data.item.tags) }}</span>
            </template>

            <template #cell(paymentFrequency)="data">
              <span class="hide-data-2">{{
                getPaymentFrequencyName(data.item.settings.paymentFrequency)
              }}</span>
            </template>

            <template #cell(status)="data">
              <div
                class="badge-status badge-success"
                v-if="data.item.authentication.accountStatus === 'ACTIVE'"
              >
                <span>Active</span>
              </div>
              <div class="badge-status badge-danger" v-else>
                <span>Inactive</span>
              </div>
            </template>

            <template #cell(actions)="data">
              <el-tooltip
                content="History"
                placement="bottom"
                class="d-inline-flex"
              >
                <span
                  class="icon-action text-blue"
                  @click.stop="
                    openSupplierHistory(
                      data.item._id,
                      data.item.businessDetails.name
                    )
                  "
                >
                  <i class="flaticon-wall-clock-1"> </i>
                </span>
              </el-tooltip>

              <ActionLink
                :basePath="'/suppliers'"
                :id="data.item._id"
                :canUpdate="canUserUpdate"
                :canRead="canUserRead"
                :linkClass="'icon-action text-info mr-2'"
                :iconExtraClass="'text-primary ml-2'"
              />

              <el-tooltip
                v-if="canUserUpdate"
                content="Change status"
                placement="bottom"
              >
                <span
                  class="icon-action text-info "
                  @click.stop="
                    changeStatus(
                      data.item._id,
                      data.item.authentication.accountStatus === 'ACTIVE'
                        ? 'INACTIVE'
                        : 'ACTIVE'
                    )
                  "
                >
                  <i class="flaticon-right-4"></i>
                </span>
              </el-tooltip>
              <el-tooltip content="Delete" placement="bottom">
                <span
                  v-if="canUserDelete"
                  class="icon-action text-danger ml-2"
                  @click="deleteOperator(data.item._id)"
                >
                  <i class="flaticon-delete"></i>
                </span>
              </el-tooltip>
            </template>
          </b-table>

          <pagination-block
            :pageCount="operatorResponse.pages"
            :total="operatorResponse.count"
            :limit="limit"
            @changeLimit="changeLimit"
            v-model="currentPage"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="preventPaginations"
            position="bottom"
          ></pagination-block>
        </div>
      </div>
    </div>
    <SupplierHistory
      :show="showSupplierHistory"
      :tempSupplierId="tempSupplierId"
      :supplierName="tempSupplierName"
      @close="closeSupplierHistoryModal"
    />
    <ManageTableColumns
      :value="modalManageColumn"
      :fields="fields"
      :tableGridConfig="tableGridConfig"
      :mandatories="['name', 'status']"
      @saveColumns="saveColumnsInUserAccount"
      @closeTableGridModal="closeTableGridModal"
    />
    <TagsManager
      :show="modalTags"
      :type="TAG_TYPES.SUPPLIER"
      @closeTagsModal="closeTagsModal"
    />
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import {
  OperatorsAPI,
  ExportAPI,
  DestinationsAPI,
  DocumentsAPI,
  SettingsAPI
} from "../../../core/api";
import { SUPPLIERS_TABLE_DEFAULTS, TAG_TYPES } from "../../../core/constants";
import { getPaymentFrequencyLabel } from "../services/supplier.service";
import { joinTagNames } from "../../../core/services/tags.service";
import ManageTableColumns from "@/components/ManageTableColumns.vue";
import TagsManager from "../../../components/TagsManager.vue";
import WSelect from "@/components/Select";
import SupplierHistory from "../components/SupplierHistory.vue";
import {
  goBack,
  isUserAuthorized
} from "../../../helpers/commons.helpers";
import { handleApiError } from "../../../core/services";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "Suppliers",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    WSelect,
    SupplierHistory: SupplierHistory,
    ManageTableColumns: ManageTableColumns,
    TagsManager: TagsManager
  },
  data() {
    return {
      selectedRows: [],
      limit: 0,
      currentPage: 1,
      query: "",
      fields: [],
      tableGridConfig: [],
      modalManageColumn: false,
      modalTags: false,
      TAG_TYPES,
      cardview: false,
      view: "table",
      simpleSearch: "",
      sortBy: "",
      sortDesc: "asc",
      sortOptions: [
        {
          value: "name",
          text: "Supplier"
        },
        {
          value: "email",
          text: "Email"
        },
        {
          value: "destinationsSummary",
          text: "Destinations"
        },
        {
          value: "ratesSummaryAffiliate",
          text: "Rates"
        },
        {
          value: "created_at",
          text: "Created At"
        }
      ],
      timeoutId: null,
      guides: [],
      loader: false,
      visibleSideBar: false,
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      filters: {
        supplier: "",
        last_name: "",
        first_name: "",
        destination: []
      },
      supplierFilter: "",
      filterStatus: "all",
      activeFilter: false,
      destinationsOptions: [],
      destinationName: "",
      queryTemp: "",
      tempSupplierId: "",
      tempSupplierName: "",
      accountStatus: "ALL",
      unaffiliated: 0,
      inactive: 0,
      showSupplierHistory: false,
      serviceType: "ALL",
      servicesProvided: [
        {
          value: "ALL",
          label: "All"
        },
        {
          value: "TRANSFERS",
          label: "Transfers"
        },
        {
          value: "PRODUCTS",
          label: "Experiences"
        }
      ]
    };
  },
  mounted() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Suppliers",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  async created() {
    this.tableGridConfig = SUPPLIERS_TABLE_DEFAULTS;
    this.fields = this.populateFields(this.settings);
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.currentPage = this.supplierSearchCriteria.currentPage;
    this.query = this.supplierSearchCriteria.query;
    this.get(true, this.limit, this.currentPage, this.query);
    this.destinationsOptions = await this.getDestinationsOptions();
    this.initializeFilterData(this.query);
    await this.getMetadata(this.query);
  },
  methods: {
    async applyFilterByStatus(status) {
      this.filterStatus = "all";
      this.accountStatus = status;
      this.queryTemp = "";
      if (status === "ALL") {
        this.query = this.deleteItemInQuery(this.query, ["status"]);
        this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.query = this.addElementInQuery(this.query, "status", status);
        this.get(true, this.limit, this.currentPage, this.query);
      }
      await this.getMetadata(this.query);
    },
    async applyFilterByService(status) {
      this.filterStatus = "all";
      this.serviceType = status;
      this.queryTemp = "";
      if (status === "ALL") {
        this.query = this.deleteItemInQuery(this.query, ["serviceType"]);
        this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.query = this.addElementInQuery(this.query, "serviceType", status);
        this.get(true, this.limit, this.currentPage, this.query);
      }
      await this.getMetadata(this.query);
    },
    filteredTab() {
      if (this.filterStatus == "all") {
        this.queryTemp = "";
        this.query = this.deleteItemInQuery(this.query, [
          "affiliate",
          "accountStatus"
        ]);
        this.get(true, this.limit, this.currentPage, this.query);
      } else if (this.filterStatus === "affiliate") {
        this.queryTemp = this.addElementInQuery(this.query, "affiliate", false);
        this.get(true, this.limit, 1, this.queryTemp);
      } else {
        this.queryTemp = this.addElementInQuery(
          this.query,
          "accountStatus",
          "INACTIVE"
        );
        this.get(true, this.limit, 1, this.queryTemp);
      }
    },
    addElementInQuery(query, key, value) {
      let parseValue = this.getValue(value);
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, parseValue);
      } else {
        searchParams.append(key, parseValue);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        if (value) {
          this.query = this.addElementInQuery(this.query, "search", value);
          this.get(true, this.limit, 1, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          this.get(true, this.limit, 1, this.query);
        }
        await this.getMetadata(this.query);
      }, 500);
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        let query = this.queryTemp ? this.queryTemp : this.query;
        this.get(true, this.limit, this.currentPage, query);
      }
    },
    preventPaginations(page) {
      this.currentPage = page;
      let query = this.queryTemp ? this.queryTemp : this.query;
      this.get(true, this.limit, this.currentPage, query);
    },
    nextPaginations(page) {
      this.currentPage = page;
      let query = this.queryTemp ? this.queryTemp : this.query;
      this.get(true, this.limit, this.currentPage, query);
    },
    changePage(page) {
      this.currentPage = page;
      let query = this.queryTemp ? this.queryTemp : this.query;
      this.get(true, this.limit, this.currentPage, query);
    },
    async deleteOperator(operatorId) {
      let { value } = await Swal.fire({
        title: "Delete Supplier",
        text: "Are you sure do you want to delete this Supplier?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteOperatorById(operatorId);
      }
    },
    async deleteOperatorById(operatorId) {
      try {
        this.setLoad(true);
        await OperatorsAPI.deleteOperatorById(
          operatorId,
          this.sesion.token
        );
        this.setLoad(false);
        this.get(true, this.limit, this.currentPage, this.query);
        await this.getMetadata(this.query);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Supplier has been Deleted",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteManyOperators() {
      let { value } = await Swal.fire({
        title: "Delete Suppliers",
        text: "Are you sure do you want to delete the selected Supplier?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyOperatorsById(this.selectedRows);
      }
    },
    async deleteManyOperatorsById(operators = []) {
      try {
        this.setLoad(true);
        await OperatorsAPI.deleteManyOperatorsById(
          { suppliers: operators },
          this.sesion.token
        );
        this.setLoad(false);
        this.get(true, this.limit, this.currentPage, this.query);
        await this.getMetadata(this.query);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Suppliers has been Deleted",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(suppliers = []) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.exportCSVOperators(
          { suppliers: suppliers },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `suppliers-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    handleError(error, message) {
      handleApiError(this, error, message);
    },
    goToPreviousPage() {
      goBack(this);
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async get(loader, limit, page, query) {
      this.setSupplierSearchCriteria({
        currentPage: page,
        limit: limit,
        query: query,
        status: true
      });
      this.getOperators({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    getValue(value) {
      if (typeof value === "string") {
        return value.trim();
      } else {
        return value;
      }
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
      this.filterStatus = searchCriteria.has("affiliate")
        ? searchCriteria.get("affiliate")
          ? "affiliate"
          : "all"
        : "all";

      this.filters.destination = searchCriteria.has("destination")
        ? searchCriteria.get("destination")
        : "";
      this.selectDestination(this.filters.destination);

      this.filters.supplier = searchCriteria.has("supplier")
        ? searchCriteria.get("supplier")
        : "";
      this.selectSupplier(this.filters.supplier);

      this.filters.first_name = searchCriteria.has("first_name")
        ? searchCriteria.get("first_name")
        : "";
      this.filters.last_name = searchCriteria.has("last_name")
        ? searchCriteria.get("last_name")
        : "";

      if (
        this.filters.destination ||
        this.filters.supplier ||
        this.filters.first_name ||
        this.filters.last_name
      ) {
        this.activeFilter = true;
      }
    },
    isInSupplierModule(modules = []) {
      if (!(modules.indexOf("suppliers") > -1)) {
        this.setSupplierSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async changeStatus(operatorId, status) {
      let { value } = await Swal.fire({
        title: "Change Status",
        text: `Are you sure do you want change status the selected Supplier?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.changeStatusById(operatorId, {
          "authentication.accountStatus": status
        });
      }
    },
    async changeStatusById(operatorId, payload) {
      try {
        this.setLoad(true);
        await OperatorsAPI.updateAnyAttributeById(
          operatorId,
          payload,
          this.sesion.token
        );
        this.setLoad(false);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "This supplier has been enabled",
          icon: "flaticon-check-mark"
        });
        this.get(false, this.limit, this.currentPage, this.query);
        await this.getMetadata(this.query);
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error updating the Supplier, please try again"
        );
      }
    },
    deleteEmptyElements(query) {
      return query
        .toString()
        .split("&")
        .filter(element => {
          let [key, value] = element.split("=");
          return key && value ? true : false;
        })
        .join("&");
    },
    async applyAdvancedSearch() {
      this.filterStatus = "all";
      let searchParams = this.buildParams({
        ...Object.fromEntries(new URLSearchParams(this.query)),
        ...this.filters
      });
      if (searchParams) {
        this.query = this.deleteEmptyElements(searchParams.toString());
        this.activeFilter = this.query ? true : false;
        await this.get(true, this.limit, this.currentPage, this.query);
        await this.getMetadata(this.query);
      }
    },
    async selectSupplier(supplierId) {
      if (supplierId) {
        let supplier = this.operatorSelections.find(
          supplier => supplier._id === supplierId
        );
        this.supplierFilter = supplier ? supplier : null;
      } else {
        this.supplierFilter = null;
      }
    },
    async resetSearchFilter() {
      this.filters.supplier = "";
      this.filters.last_name = "";
      this.filters.first_name = "";
      this.filters.destination = "";
      this.destinationName = "";
      this.filterStatus = "all";
      this.activeFilter = false;
      this.query = "";
      this.currentPage = 1;
      this.simpleSearch = "";
      this.supplierFilter = null;
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async getDestinationsOptions() {
      try {
        let { data } = await DestinationsAPI.getDestinationsOptions(
          this.sesion.token
        );
        if (data.status) {
          let destinations = data.data || [];
          return this.sortByCityName(destinations);
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    selectDestination(slug) {
      let destination = this.destinationsOptions.find(
        destination => destination.slug === slug
      );
      if (destination) {
        this.destinationName = destination.city;
      }
    },
    sortByCityName(destinations = []) {
      return destinations.sort((a, b) => {
        const firstCity = a.city.toUpperCase();
        const secondCity = b.city.toUpperCase();
        if (firstCity < secondCity) {
          return -1;
        }
        if (firstCity > secondCity) {
          return 1;
        }
        return 0;
      });
    },
    closeTableGridModal(status) {
      this.modalManageColumn = status;
    },
    async saveColumnsInUserAccount(fields = []) {
      this.modalManageColumn = false;
      this.fields = fields;
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.suppliers.tableLayouts": this.fields }
      );
      if (status) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "Columns have been changed",
          icon: "flaticon-check-3"
        });
        this.setSettings(settings);
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "Columns haven't been changed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateSettingLayoutsByUserId(userId, payload) {
      try {
        let { data } = await SettingsAPI.updateSettingLayoutsByUserId(
          userId,
          payload,
          this.sesion.token
        );
        if (data.status) {
          return { status: true, settings: data.data.settings };
        } else {
          return { status: false, settings: null };
        }
      } catch (error) {
        return { status: false, settings: null };
      }
    },
    /**
     * Get the columns of the suppliers table: the layout saved by the user or the default columns.
     * @param {Object} settings - The user settings.
     * @returns {Object[]} The table columns.
     */
    populateFields(settings) {
      try {
        if (settings && settings.suppliers.tableLayouts.length > 0) {
          return settings.suppliers.tableLayouts;
        }
        return this.getDefaultFields();
      } catch (error) {
        return this.getDefaultFields();
      }
    },
    /**
     * Get the columns of the suppliers table that are visible by default.
     * @returns {Object[]} The default table columns.
     */
    getDefaultFields() {
      return SUPPLIERS_TABLE_DEFAULTS.filter(option => option.settings.default);
    },
    closeTagsModal() {
      this.modalTags = false;
    },
    /**
     * Get the tag names of a supplier for the tags column.
     * @param {Object[]} tags - The supplier tags ({ ref, name, slug }).
     * @returns {string} The tag names separated by " | ".
     */
    getTagNames(tags = []) {
      return joinTagNames(tags);
    },
    /**
     * Get the payment frequency label of a supplier for the payment frequency column.
     * @param {string|null} paymentFrequency - The stored payment frequency.
     * @returns {string} The payment frequency label.
     */
    getPaymentFrequencyName(paymentFrequency) {
      return getPaymentFrequencyLabel(paymentFrequency);
    },
    getPreferredContactMethod(method) {
      return method === "phoneNumber" ? "Phone" : "Email";
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The data has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The data couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    getPhoneNumber(phoneNumbers = []) {
      let phone = phoneNumbers.find(phone => phone.preferred);
      if (phone) {
        return phone.number;
      } else {
        return "";
      }
    },
    buildParams(data) {
      const params = new URLSearchParams();
      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(item =>
            params.append(key, item ? item.toString() : "")
          );
        } else {
          params.append(key, value ? value.toString() : "");
        }
      });
      return params.toString();
    },
    async getMetadata(query) {
      try {
        let { data } = await OperatorsAPI.getOperatorsMetadata(
          query,
          this.sesion.token
        );
        let metadata = data;
        this.unaffiliated = metadata.unaffiliated;
        this.inactive = metadata.inactive;
      } catch (error) {
        this.unaffiliated = 0;
        this.inactive = 0;
      }
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "SUPPLIERS");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    openSupplierHistory(supplierId, supplierName) {
      this.tempSupplierId = supplierId;
      this.tempSupplierName = supplierName;
      this.showSupplierHistory = true;
    },
    closeSupplierHistoryModal() {
      this.showSupplierHistory = false;
    },
    getServiceType(serviceType) {
      if (serviceType === "PRODUCTS") {
        return "Experience";
      } else {
        return "Transfer";
      }
    },
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setSupplierSearchCriteria",
      "setSettings"
    ]),
    ...mapActions(["getOperators", "getLimit"])
  },
  computed: {
    operators: function() {
      if (this.operatorResponse.docs) {
        return this.operatorResponse.docs;
      } else {
        return [];
      }
    },
    ...mapGetters([
      "operatorResponse",
      "sesion",
      "userRole",
      "load",
      "paginationLimit",
      "supplierSearchCriteria",
      "operatorSelections",
      "settings"
    ]),
    canUserCreate() {
      return isUserAuthorized("SUPPLIERS", this.userRole, "CREATE");
    },
    canUserUpdate() {
      return isUserAuthorized("SUPPLIERS", this.userRole, "UPDATE");
    },
    canUserDelete() {
      return isUserAuthorized("SUPPLIERS", this.userRole, "DELETE");
    },
    canUserRead() {
      return isUserAuthorized("SUPPLIERS", this.userRole, "READ");
    },
    canUserExport() {
      return isUserAuthorized("SUPPLIERS", this.userRole, "EXPORT");
    },
    canUserCreateTag() {
      return isUserAuthorized("TAGS", this.userRole, "CREATE");
    }
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  beforeRouteLeave(to, from, next) {
    this.isInSupplierModule(to.meta.modules);
    next();
  }
};
</script>
